
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M8.375 5.542v5.666M5.542 8.375h5.666M3.417 2h9.916c.783 0 1.417.634 1.417 1.417v9.916c0 .783-.634 1.417-1.417 1.417H3.417A1.417 1.417 0 0 1 2 13.333V3.417C2 2.634 2.634 2 3.417 2"}})])
          )
        }
      }
    